module.exports = __webpack_public_path__ + "ac72984483ee44e24e4bf592cab7c996.jpg";